import ua from '@ali/simple-ua';
import constants from '../constants/init';
const initState = {
  env: setEnv(),
};

function setEnv() {
  // 0 非用户 -1：ios 1：用户
  let env = 0;
  if (ua.os !== 'ANDROID') env = -1;
  const _uc = ua.pf === 'UC' && ua.isUCLatestVersion('10.7');
  // const _mini = ua.pf === 'UC_MINI' && ua.isUCLatestVersion('10.5');
  const _ucnews = ua.pf === 'UCNEWS';
  if (ua.os === 'ANDROID' && (_uc || _ucnews)) env = 1;
  return env;
}

function reducers(state = initState, action) {
  switch (action.type) {
    case constants.QUERY: {
      return {
        ...state,
        ...action.data,
      };
    }
    default: {
      return state;
    }
  }
}

export default reducers;
